import { compose, withProps, pure } from 'recompose'
import { useNavigate, useLocation, useParams } from 'react-router-dom'

/**
 * This is a temporary stop-gap HOC that uses the hooks from react-router-dom.
 * This is designed to replace withRouter since that's going to be deprecated.
 */
export default compose(
  withProps(() => {
    const navigate = useNavigate()
    const location = useLocation()
    const params = useParams()

    return {
      navigate,
      location,
      params,
    }
  }),
  pure,
)
